export class PaymentCharge {
    constructor (
        public ChargeAmount: number = 0,
        public ChargeCurrency: string = '',
        public ChargeToken: string = '',
        public ChargeEmail: string = '',
        public PropertyId: string = '',
        public PublicToken: string = ''
    ) { }
}
